export default __webpack_public_path__ + "static/fv-nr-5-8623b4d6e1723f1b88ddf29a2503fea4.png";